import { useEffect, useState } from "react";

const HouseAfterContent = () => {
  const COLORS = {
    primaryGreen: "#5ec250",
    lightGray: "#f0f0f0",
    border: "#e0e0e0",
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const styles = {
    container: {
      maxWidth: "1100px",
      margin: "0 auto",
      padding: isMobile ? "40px 16px" : "60px 20px",
      overflowX: "hidden",
      fontFamily: "'Plus Jakarta Sans', sans-serif",
    },

    title: {
      fontSize: isMobile ? "22px" : "26px",
      fontWeight: 500,
      lineHeight: 1.3,
      marginBottom: "20px",
      color: "#494040",
    },

    highlight: {
      color: COLORS.primaryGreen,
    },

    description: {
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: 1.8,
      color: "#454343",
      marginBottom: "18px",
    },

    faqSection: {
      marginTop: "50px",
      background: "#f9f9f9",
      padding: "30px",
      borderRadius: "18px",
    },

    faqTitle: {
      fontSize: "24px",
      fontWeight: "600",
      marginBottom: "20px",
      textAlign: "center",
      color: "#333",
    },

    faqItem: {
      marginBottom: "20px",
      borderBottom: "1px solid #ddd",
      paddingBottom: "15px",
    },

    faqQuestion: {
      fontSize: "18px",
      fontWeight: "600",
      color: "#444",
      marginBottom: "8px",
    },

    faqAnswer: {
      fontSize: "16px",
      color: "#666",
      lineHeight: "1.6",
    },

    topSection: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
      gap: "40px",
      marginBottom: "50px",
    },

    topLeft: {
      textAlign: isMobile ? "center" : "left",
    },

    topRight: {
      display: "flex",
      justifyContent: isMobile ? "center" : "start",
    },

    imageWrapper: {
      position: "relative",
      maxWidth: "420px",
    },

    topImage: {
      width: "100%",
      borderRadius: "18px",
      objectFit: "cover",
      position: "relative",
      zIndex: 2,
    },

    tiltBg: {
      position: "absolute",
      top: "14px",
      width: "100%",
      height: "80%",
      background: "#e5e5e5",
      borderRadius: "18px",
      transform: "rotate(-4deg)",
      zIndex: 1,
    },

    bottomGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "2fr 3fr",
      gap: "28px",
      alignItems: "stretch",
    },

    greenCard: {
      background: COLORS.primaryGreen,
      color: "#fff",
      padding: "26px",
      borderRadius: "5px",
      fontSize: "15px",
      lineHeight: 1.5,
    },

    whiteCard: {
      background: "#fff",
      border: "1px solid #ddd",
      padding: "28px",
      borderRadius: "18px",
      height: "100%",
    },

    imageWrapperGrid: {
      gridColumn: isMobile ? "auto" : "2",
      height: "100%",
    },

    imageCard: {
      width: "100%",
      height: "100%",
      borderRadius: "18px",
      objectFit: "cover",
    },
  };

  const faqs = [
    {
      q: "What types of houses can I find in Trichy?",
      a: "Mitha Homes offers a variety of individual houses, villas, and independent homes in 2BHK and 3BHK configurations across prime locations in Trichy.",
    },
    {
      q: "What are the benefits of buying an independent house in Trichy?",
      a: "Independent houses offer more privacy, freedom for future expansions, and a dedicated land portion, making them a preferred choice for many families.",
    },
    {
      q: "Is buying a house in Trichy a good investment?",
      a: "Yes, land value appreciation in Trichy is significant, especially in developing residential hubs, ensuring excellent long-term returns on your investment.",
    },
    {
      q: "What should I check before buying a house or villa?",
      a: "Check the DTCP/CMDA approval, land documents, quality of construction, builder's track record, and availability of basic amenities like water and electricity.",
    },
    {
      q: "Does Mitha Homes provide gated community houses?",
      a: "Yes, many of our house projects are part of secure gated communities that offer a blend of independent living and shared security/amenities.",
    },
    {
      q: "Why choose Mitha Homes for houses in Trichy?",
      a: "With years of experience, Mitha Homes is known for delivering high-quality, legally clear, and aesthetically pleasing houses that turn into cherished homes.",
    },
  ];

  return (
    <div style={styles.container}>
      {/* ---------- TOP ---------- */}
      <div style={styles.topSection}>
        <div style={styles.topLeft}>
          <h2 style={styles.title}>
            Experience Space, Style & Modern Living  <br />
          </h2>

          <p style={styles.description}>
            Discover your perfect house in Trichy with Mitha Homes, where thoughtful design meets comfort and elegance. Our homes are created for families who value space, style, and a modern lifestyle in a peaceful environment. <br /> <br />
            Each house is designed with attention to detail, offering spacious living areas, well-planned bedrooms, modern kitchens, and stylish bathrooms. Every element is carefully crafted to deliver a perfect balance of functionality and sophistication.  <br /><br />
            Whether you are looking for a comfortable family home or a premium residence in a prime location, Mitha Homes offers houses that suit your needs. Located in well-connected neighborhoods, our properties provide easy access to leading schools, hospitals, shopping centers, and key transport routes. <br /><br />
            Choose a house for sale in Trichy that offers not just comfort, but also long-term value—making it an ideal choice for both homeowners and investors.
          </p>
        </div>

        <div style={styles.topRight}>
          <div style={styles.imageWrapper}>
            <div style={styles.tiltBg}></div>
            <img
              src="https://mithahomes.com/backend/uploads/home/image1.png"
              alt="Luxury Houses Trichy"
              style={styles.topImage}
            />
          </div>
        </div>
      </div>

      {/* ---------- BOTTOM GRID ---------- */}
      <div style={styles.bottomGrid}>
        <div style={styles.greenCard}>
          <h2 style={{ ...styles.title, color: "#fff" }}>
            Luxury Living with Elegance & Comfort
          </h2>
          <p>
            Discover a premium house for sale in Trichy with Mitha Homes, thoughtfully designed for those who value elegance, comfort, and a modern way of living. Each home is built using quality materials, contemporary architecture, and refined finishes to create a truly elevated lifestyle experience. <br /><br />
            Every 3bhk house for in Trichy is planned to offer spacious interiors, well-designed layouts, and modern features that enhance everyday living. From open living spaces to functional kitchens and stylish interiors, every detail is crafted with care.<br /><br />
            Situated in prime residential locations, our homes provide excellent connectivity to major parts of the city, along with easy access to schools, hospitals, and shopping hubs—ensuring convenience at every step.
          </p>
        </div>

        <div style={styles.whiteCard}>
          <h2 style={styles.title}>Find the Perfect House for Sale in Trichy at Prime Locations</h2>
          <p style={styles.description}>
            At Mitha Homes, we present a carefully selected range of houses for sale in Trichy located in some of the city’s most desirable neighborhoods. Whether you are buying your first home or moving to a more spacious residence, our projects are designed to suit different lifestyles and budgets. <br /> <br />
            Our offerings in house sale in Trichy include thoughtfully planned 2BHK and 3BHK individual houses, along with secure gated community residences. Each home is built with a focus on modern living, combining functionality, comfort, and style.<br /> <br />
            From premium houses in Trichy to high-value residential options, our homes offer excellent connectivity, quality construction, and a superior living environment—making them a smart choice for both families and investors.
          </p>
        </div>

        <div style={styles.whiteCard}>
          <h2 style={styles.title}>Enjoy a Secure Lifestyle with Gated Community Houses</h2>
          <p style={styles.description}>
            Step into a better way of living with our luxury houses in Trichy, designed for safety, comfort, and peace of mind.<br /><br />
            These residential communities offer:<br />
            • Round-the-clock security<br />
            • Beautifully landscaped surroundings<br />
            • Dedicated private parking<br />
            • Family-friendly environment<br /><br />
            Living in a gated community not only enhances your lifestyle but also provides a secure and peaceful atmosphere for you and your loved ones.
          </p>
        </div>

        <div style={styles.imageWrapperGrid}>
          <img
            src="https://mithahomes.com/backend/uploads/home/image8.jpg"
            alt="Individual House Trichy"
            style={styles.imageCard}
          />
        </div>
      </div>

      {/* ---------- FAQ ---------- */}
      <div style={styles.faqSection}>
        <h2 style={styles.faqTitle}>FAQs – Buying Houses in Trichy</h2>
        {faqs.map((f, i) => (
          <div key={i} style={styles.faqItem}>
            <p style={styles.faqQuestion}>{f.q}</p>
            <p style={styles.faqAnswer}>{f.a}</p>
          </div>
        ))}
      </div>

      <div
        style={{
          marginTop: "40px",
          textAlign: "center",
          padding: "40px",
          background: "#333",
          color: "#fff",
          borderRadius: "18px",
        }}
      >
        <h2 style={{ color: "#fff" }}>Begin Your Journey to the Perfect House for Sale in Trichy with Mitha Homes</h2>
        <p style={{ fontSize: "18px", marginTop: "10px" }}>
          At Mitha Homes, we are dedicated to helping you discover the ideal house for sale in Trichy that aligns with your lifestyle, preferences, and long-term goals. Whether you're looking for a modern family home or a smart investment, we offer the right choices in house sale in Trichy. <br /> <br />
          Connect with us today and take the first step toward owning a home that truly reflects your dreams and aspirations.
        </p>
      </div>
    </div>
  );
};

export default HouseAfterContent;
